// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".uRavj{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}._1gHMW{fill:#30a8ff;height:225px;height:22.5rem;width:225px;width:22.5rem}", ""]);
// Exports
exports.locals = {
	"loaderContainer": "uRavj",
	"loader": "_1gHMW"
};
module.exports = exports;
